import { useAppState } from '@/features/authorization/provider/useAppState';
import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { MILLISECONDS_UNTIL_POST_IS_OLD } from '@/shared/constants/newPosts';
import { useBadgeStore } from '@/shared/store/useBadgeStore';

const useIsPostcardNew = (): boolean => {
  const { userId: ownUserId } = useAppState();
  const { creator, created, postId } = usePostCard();
  const isRecentlyCreated =
    (created ?? 0) >
    // oxlint-disable-next-line react/purity
    Date.now() - MILLISECONDS_UNTIL_POST_IS_OLD;
  const isUnread = !useBadgeStore((state) =>
    state.readPostBadgeEntries.some((it) => it.id === postId)
  );
  const isNotOwnPost = creator?.id !== ownUserId;
  return isRecentlyCreated && isUnread && isNotOwnPost;
};
export default useIsPostcardNew;
